import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Search } from "lucide-react";
import { useWorkspace } from "../../features/workspace";
import {
  DEFAULT_NAV_ORDER,
  MAX_TAB_SLOTS,
  NavItemIcon,
  TAB_CONTEXT,
  useMobileNavCatalog,
} from "./mobileNavCatalog";

export { NAV_REGISTRY, DEFAULT_NAV_ORDER } from "./mobileNavCatalog";

interface BottomNavProps {
  onOpenCommandPalette: () => void;
}

const BottomNav: React.FC<BottomNavProps> = ({ onOpenCommandPalette }) => {
  const location = useLocation();
  const { getPinnedOrder } = useWorkspace(TAB_CONTEXT);
  const { resolve } = useMobileNavCatalog();

  const savedOrder = getPinnedOrder();
  const items = (savedOrder.length > 0 ? savedOrder : DEFAULT_NAV_ORDER)
    .slice(0, MAX_TAB_SLOTS)
    .map((key) => resolve(key))
    .filter((item): item is NonNullable<typeof item> => item !== null);

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <nav
      className="mobile-bottom-nav"
      aria-label="Main navigation"
      style={{ paddingBottom: "calc(0.5rem + env(safe-area-inset-bottom))" }}
    >
      {items.map((item) => {
        const active = isActive(item.to);
        return (
          <Link
            key={item.key}
            to={item.to}
            className={`mobile-bottom-nav-item ${active ? "mobile-bottom-nav-item--active" : ""}`}
            aria-current={active ? "page" : undefined}
          >
            <NavItemIcon item={item} size={22} strokeWidth={active ? 2.2 : 1.8} />
            <span className="truncate max-w-full px-1">{item.label}</span>
          </Link>
        );
      })}

      <button
        type="button"
        className="mobile-bottom-nav-item"
        onClick={onOpenCommandPalette}
        aria-label="Search all modules"
      >
        <Search size={22} strokeWidth={1.8} />
        <span>Search</span>
      </button>
    </nav>
  );
};

export default BottomNav;
